import './Loader.scss';

interface IProps {
  height?: string;
  color?: 'white' | 'black';
}

function Loader({ height, color = 'black' }: IProps) {
  return (
    <div className='loader-wrapper' style={{ height }}>
      <div className={`loader loader--${color}`} />
    </div>
  );
}

export default Loader;
